'use client';

import { ReactNode, useEffect, useState } from 'react';
import { Img } from '@/shared/components/ui/Img';

type BrowserSupportProviderProps = {
    children: ReactNode;
};

export function BrowserSupportProvider({ children }: BrowserSupportProviderProps) {
    const [isUnsupportedBrowser, setIsUnsupportedBrowser] = useState(false);

    useEffect(() => {
        setIsUnsupportedBrowser(detectIsIE());
    }, []);

    if (isUnsupportedBrowser) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="cust-container">
                    <div className="flex flex-col items-center gap-[16px] text-center">
                        <Img src="/images/hero_logo.png" alt="Realico logo" />
                        <h1 className="text-[22px] font-[700] tracking-[-0.5px] md:text-[26px] xl:text-[30px]">
                            Webová stránka nepodporuje zastarané prehliadače.
                        </h1>
                        <p className="text-[13px] text-muted-foreground font-[500] md:text-[14px] xl:text-[15px]">
                            Použite prosím novší prehliadač.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return <>{children}</>;
}

function detectIsIE(): boolean {
    if (typeof window === 'undefined') return false;

    return Boolean((window.document as Document & { documentMode?: unknown }).documentMode);
}
